<div #deckBannerOuter class="shadow text-white">
    <div #deckBannerInner class="flex flex-row">
        <div class="hidden md:block w-[5%]"></div>
        <div class="flex flex-col gap-2 p-5">
            <div class="text-2xl font-bold">
                <input type="text" value="{{ deck.name }}" class="bg-transparent overflow-visible w-[24ch] md:w-[48ch]" (focusout)="onTitleLoseFocus($event)">
            </div>
            <div class="flex flex-row gap-2 text-sm">
                <div>{{ deck.game }}</div>
                <div>|</div>
                <div>{{ deck.type }}</div>
                <div>|</div>
                @if (deckComponent.isOwnDeck) {
                    <div>{{ deck.visibility }}</div>
                    <div>|</div>
                }
                <div>
                    <span title="Created on {{ deckComponent.createdAt }}">Updated {{ deckComponent.updatedAt }}</span>
                </div>
            </div>
        </div>
    </div>
</div>